import { useEffect, useState } from "react";
import api from "@/lib/api";
import SectionHeader from "@/components/layout/SectionHeader";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section data-testid="testimonials" className="container-page py-16 md:py-24">
      <SectionHeader
        align="center"
        kicker="Loved by Travellers"
        title="What our community says"
        subtitle="Real reviews from Indian travellers who used MyTripPoint to plan and book their journeys."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map((t, i) => (
          <div
            key={t.id || i}
            data-testid={`testimonial-${i}`}
            className="bg-white rounded-2xl border border-slate-200 p-6 relative card-hover"
          >
            <Quote size={20} className="text-accent absolute top-5 right-5 opacity-60" />
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: t.rating || 5 }).map((_, j) => (
                <Star key={j} size={14} className="text-accent fill-accent" />
              ))}
            </div>
            <p className="text-sm text-slate-700 leading-relaxed">"{t.text}"</p>
            <div className="mt-5 flex items-center gap-3">
              <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-slate-200" />
              <div>
                <div className="text-sm font-semibold text-slate-900">{t.name}</div>
                <div className="text-xs text-slate-500">{t.city}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
